import { useEffect, useState } from "react";
import { useFetchProductsData } from "../../Hooks/useProductsData";
import ProductSkeleton from "../ProductSkeleton/ProductSkeleton";
import ProductCard from "../ProductCard/ProductCard";
import { Col, Empty, Row } from "antd";

import styles from './ProductsBySubSubcategoryListing.module.scss';
import { useDebounce } from "../../Hooks/useDebounce";

/*
export interface ProductsBySubSubcategoryListingProps {
  subcategory: string;
  filterNutriScore: never[];
  filterBrands: never[];
  desktopFilters: never[];
  subSubCategory: SubSubCategory;
}
*/

export const ProductsBySubSubcategoryListing = (props) => {
    const {
        subcategory,
        filterNutriScore,
        filterBrands,
        desktopFilters,
        subSubCategory,
        sortBy,
        query
    } = props;

    const [page, setPage] = useState(1);
    const debouncedQuery = useDebounce(query, 500);

    useEffect(() => {
        setPage(1);
    }, [query]);

    const [products, { loading, count }] = useFetchProductsData({
        page,
        sortBy,
        slug: subcategory,
        selectedSubcategories: [String(subSubCategory.id)],
        filterNutriScore,
        filterBrands,
        query: debouncedQuery,
        desktopFilters
    });

    // a section only finds out it is empty once its products arrive, so until
    // then it holds its place with one row of placeholders
    if (loading && !products.length) {
        return (
            <div>
                <div className={styles.products_number}>
                    <div className={styles.subcat_name}> {subSubCategory.name} </div>
                </div>
                <div className="pt-4">
                    <ProductSkeleton count={6} />
                    <div className="mt-3" />
                </div>
            </div>
        );
    }

    if (!products.length) {
        return null;
    }

    return (
        <div>
            <Row>
                <Col lg={24} xs={24}>
                    <div className={styles.products_number}>
                        <div className={styles.subcat_name}> {subSubCategory.name} </div>
                        <div className={styles.prod_count}> {count} Articles</div>
                    </div>
                </Col>
            </Row>
            <div className="pt-4">
                {loading ? (
                    <ProductSkeleton />
                ) : (
                    <>
                        {products?.length > 0 ? (
                            <div className="row g-4">
                                {products?.map((product, index) => (
                                    <div className="col-6 col-lg-2" key={index}>
                                        <ProductCard product={product} />
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="col-12 text-center">
                                <Empty description="No Products Found." />
                            </div>
                        )}
                    </>
                )}
                <div className="mt-3" />
            </div>
        </div>
    )
}